import { Component } from "preact";
import style from "./style.css";
import { connect } from "preact-redux";

class YearSelector extends Component {
  render() {
    const { selectedYear, onSelectYear, generalInfo } = this.props;
    return (
      <div className={style.wrapper}>
        <span>select the year</span>
        {generalInfo && generalInfo.timespan ? (
          selectedYear <= generalInfo.timespan.min ? null : (
            <i
              onClick={() => onSelectYear(selectedYear - 1)}
              className="fas fa-caret-left"
            />
          )
        ) : null}
        <ul>
          {generalInfo && generalInfo.timespan ? (
            selectedYear <= generalInfo.timespan.min ? null : (
              <li>{selectedYear - 1}</li>
            )
          ) : null}
          <li className={style.selected}>{selectedYear}</li>
          {generalInfo && generalInfo.timespan ? (
            selectedYear >= generalInfo.timespan.max ? null : (
              <li>{selectedYear + 1}</li>
            )
          ) : null}
        </ul>
        {generalInfo && generalInfo.timespan ? (
          selectedYear >= generalInfo.timespan.max ? null : (
            <i
              onClick={() => onSelectYear(selectedYear + 1)}
              className="fas fa-caret-right"
            />
          )
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const generalInfo = state.generalInfo.data;
  return {
    generalInfo,
  };
};

export default connect(mapStateToProps)(YearSelector);



// WEBPACK FOOTER //
// ./components/yearSelector/index.js